import { ClickAwayListener } from '@mui/material';
import React from 'react';

export interface IClickAwayAndKeydownListenerProps {
  children: React.ReactElement;
  triggerKeys?: KeyboardEvent['key'][];
  containerRef?: React.RefObject<HTMLElement> | null;
  handleTrigger(e?: MouseEvent | TouchEvent): void;
  keydownCallbacks?(e: KeyboardEvent, clickHappenedInside: boolean): void;
  /** When true, disables the default Enter and Space key trigger functionality */
  disableAutoFocusTrigger?: boolean;
}

export const ClickAwayAndKeydownListener: React.FC<IClickAwayAndKeydownListenerProps> = ({
  children,
  triggerKeys = [],
  containerRef = null,
  handleTrigger,
  keydownCallbacks,
  disableAutoFocusTrigger = false
}) => {
  React.useEffect(() => {
    const handleKeydown = (keyboardEvent: KeyboardEvent) => {
      const keydownHappenedInContainer = Boolean(
        containerRef?.current && containerRef.current?.contains(keyboardEvent.target as Node)
      );
      if (keydownCallbacks) keydownCallbacks(keyboardEvent, keydownHappenedInContainer);
      if (triggerKeys.includes(keyboardEvent.key)) {
        handleTrigger();
      } else if (!disableAutoFocusTrigger && (keyboardEvent.key === 'Enter' || keyboardEvent.key === ' ')) {
        const focusedElement = document.activeElement;
        if (containerRef?.current && !containerRef?.current.contains(focusedElement)) {
          handleTrigger();
        }
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return () => document.removeEventListener('keydown', handleKeydown);
  }, [triggerKeys, handleTrigger, disableAutoFocusTrigger]);
  return <ClickAwayListener onClickAway={handleTrigger}>{children}</ClickAwayListener>;
};
